import { z } from 'zod';

export const postalItemDetailSchema = z.object({
  plateNumber: z.string(),
  receiver: z.string(),
  status: z.enum(['未領取', '已領取', '退貨中', '已退貨']),
  type: z.string(),
  position: z.string(),
  remark: z.string(),
  createdTime: z.string(),
  receiveTime: z.string(),
  signature: z.string(),
  photo: z.string(),
});

export type PostalItemDetail = z.infer<typeof postalItemDetailSchema>;
